import { Injectable } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { AppSettings } from '../model';
import { AlertService } from './alert.service';

@Injectable({
  providedIn: 'root'
})
export class UpdateService {
  constructor(private updates: SwUpdate, private alert: AlertService) {}

  showUpdate() {
    this.alert.confirm({
      title: 'App Updated',
      message:
        `A new update for GiantSMS has been detected - (v${AppSettings.CLIENT_VERSION}).
        <br>
        <br>
         Update details:
         <ol>
         <li>Major improvements</li>
         <li>Bug fixes</li>
         </ol>
        <br>
        Kindly confirm to <b>INSTALL</b> the update.
        <br>
        <br>
        `,
      confirmText: 'INSTALL',
      callback: option => {
        if (option) {
          this.updates.activateUpdate().then(() => {
            document.location.reload();
          });
        }
      }
    });
  }

}
